
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as localeiBPygKxnMhrhp6PtK_SduTjLGh4D6kFZQdA_450JQy73YMeta } from "/app/pages/locale.vue?macro=true";
import { default as faqsPxQ7NvP8CCJjN_45RcUzHXQj4QR51RrUTzinIfDmSgPOcMeta } from "/app/pages/products/[customerType]/[slug]/faqs.vue?macro=true";
import { default as indexZ2mgLS2aBGTb9QE8liKlPUjzj6t0oIyBcEOPEiRQYVkMeta } from "/app/pages/products/[customerType]/[slug]/index.vue?macro=true";
import { default as _91article_slug_93Rb0FrLLTgfXg0XF6B_451petILUjRyjGnXHlJ0T7Vfte4Meta } from "/app/pages/products/[customerType]/[slug]/kb/[article_slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___pt-br",
    path: "/pt-br",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en-us",
    path: "/en-us",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "locale___pt-br",
    path: "/pt-br/locale",
    meta: localeiBPygKxnMhrhp6PtK_SduTjLGh4D6kFZQdA_450JQy73YMeta || {},
    component: () => import("/app/pages/locale.vue")
  },
  {
    name: "locale___en-us",
    path: "/en-us/locale",
    meta: localeiBPygKxnMhrhp6PtK_SduTjLGh4D6kFZQdA_450JQy73YMeta || {},
    component: () => import("/app/pages/locale.vue")
  },
  {
    name: "products-customerType-slug-faqs___pt-br",
    path: "/pt-br/products/:customerType()/:slug()/faqs",
    meta: { ...(faqsPxQ7NvP8CCJjN_45RcUzHXQj4QR51RrUTzinIfDmSgPOcMeta || {}), ...{"middleware":"check-product-slug"} },
    component: () => import("/app/pages/products/[customerType]/[slug]/faqs.vue")
  },
  {
    name: "products-customerType-slug-faqs___en-us",
    path: "/en-us/products/:customerType()/:slug()/faqs",
    meta: { ...(faqsPxQ7NvP8CCJjN_45RcUzHXQj4QR51RrUTzinIfDmSgPOcMeta || {}), ...{"middleware":"check-product-slug"} },
    component: () => import("/app/pages/products/[customerType]/[slug]/faqs.vue")
  },
  {
    name: "products-customerType-slug___pt-br",
    path: "/pt-br/products/:customerType()/:slug()",
    meta: { ...(indexZ2mgLS2aBGTb9QE8liKlPUjzj6t0oIyBcEOPEiRQYVkMeta || {}), ...{"middleware":"check-product-slug"} },
    component: () => import("/app/pages/products/[customerType]/[slug]/index.vue")
  },
  {
    name: "products-customerType-slug___en-us",
    path: "/en-us/products/:customerType()/:slug()",
    meta: { ...(indexZ2mgLS2aBGTb9QE8liKlPUjzj6t0oIyBcEOPEiRQYVkMeta || {}), ...{"middleware":"check-product-slug"} },
    component: () => import("/app/pages/products/[customerType]/[slug]/index.vue")
  },
  {
    name: "products-customerType-slug-kb-article_slug___pt-br",
    path: "/pt-br/products/:customerType()/:slug()/kb/:article_slug()",
    meta: { ...(_91article_slug_93Rb0FrLLTgfXg0XF6B_451petILUjRyjGnXHlJ0T7Vfte4Meta || {}), ...{"middleware":"check-product-slug"} },
    component: () => import("/app/pages/products/[customerType]/[slug]/kb/[article_slug].vue")
  },
  {
    name: "products-customerType-slug-kb-article_slug___en-us",
    path: "/en-us/products/:customerType()/:slug()/kb/:article_slug()",
    meta: { ...(_91article_slug_93Rb0FrLLTgfXg0XF6B_451petILUjRyjGnXHlJ0T7Vfte4Meta || {}), ...{"middleware":"check-product-slug"} },
    component: () => import("/app/pages/products/[customerType]/[slug]/kb/[article_slug].vue")
  }
]